var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("el-switch", {
    attrs: { disabled: "" },
    model: {
      value: _vm.readOnly,
      callback: function ($$v) {
        _vm.readOnly = $$v
      },
      expression: "readOnly",
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }